import React, { useState, useEffect } from "react";
import EventEntries from "./EventEntries/EventEntries";
import EventPayoutConfirmation from "../Payouts/EventPayoutConfirmation";
import { supabase } from "../../supabaseClient";

const PayoutDashBoard = ({ tournamentId }) => {
  const [tournamentEvents, setTournamentEvents] = useState([]);

  useEffect(() => {
    const fetchTournamentEvents = async () => {
      try {
        const { data, error } = await supabase
          .from("tournamentEvents")
          .select("*")
          .eq("tournamentID", tournamentId)
          .eq("isDeleted", false);

        if (error) throw error;
        setTournamentEvents(data);
      } catch (error) {
        console.error("Error fetching tournament events:", error);
      }
    };

    if (tournamentId) {
      fetchTournamentEvents();
    }
  }, [tournamentId]);

  return (
    <div className="space-y-6">
      <EventEntries />
      <EventPayoutConfirmation
        tournamentId={tournamentId}
        tournamentEvents={tournamentEvents}
      />
    </div>
  );
};

export default PayoutDashBoard;
